import React from "react";
import InfoUser from "../component/sections/user/InfoUser";

const userRoutes = [
  {
    path: "/user/info",
    render: () => <InfoUser />,
    exact: true,
  },
];

export default userRoutes;
